import { useState, useEffect } from 'react';
import { List, PagedList } from 'src/types/common';
import { client } from 'src/utils/axios-client';

// 3rd party components
import InfiniteScroll from 'react-infinite-scroll-component';
import PerfectScrollbar from 'react-perfect-scrollbar'
import "react-perfect-scrollbar/dist/css/styles.css";
import Box from '@mui/material/Box'
import _, { filter } from 'lodash';
import { OptionWithSelect } from '../autocomplete/types';
import { Filter } from '../filters/FilterTypes';

type ComponentProps<T> = {
    item: T
}

type Props<T> = {
    listName: string
    queryRecordsEndpoint: string,
    searchTerm: string,
    filter: Filter,
    /*filters: OptionWithSelect[],*/
    Component: React.FC<ComponentProps<T>>,
    list: PagedList<T>,
    updateList: (list: PagedList<T>) => void
}

const BasicList = <T extends unknown>({ queryRecordsEndpoint, filter, listName, Component, list, updateList, searchTerm }: Props<T>) => {
    useEffect(() => {
        loadRecords(1, list.pageSize);
    }, [filter, searchTerm]);

    const loadRecords = async (pageNumber: number, pageSize: number) => {
        const response = await client.post<PagedList<T>>(queryRecordsEndpoint, { pageNumber, pageSize, ...filter, startDate: filter.startDate != '' ? filter.startDate : null, endDate: filter.endDate != '' ? filter.endDate : null });
        const newItems = [...list.items, ...response.data.items];

        updateList({
            ...response.data,
            items: pageNumber === 1 ? response.data.items : newItems
        });
    }

    const onNextPage = () => {
        loadRecords(list.pageNumber + 1, list.pageSize);
    }

    return <PerfectScrollbar options={{ wheelPropagation: false }} id={listName}>
        <Box sx={{ height: 750 }}>
            <InfiniteScroll
                dataLength={list.items.length}
                next={onNextPage}
                hasMore={list.totalCount > list.items.length}
                loader={<h4>Loading...</h4>}
                scrollableTarget={listName}
                endMessage={
                    <p style={{ textAlign: 'center' }}>
                        <b>Yay! You have seen it all</b>
                    </p>
                }
            >
                {list.items.map((item, index) =>
                    <Box sx={{ mb: 4, mr: 4 }} key={`lead-${index}`}>
                        <Component item={item} />
                    </Box>)
                }
            </InfiniteScroll>
        </Box>
    </PerfectScrollbar>
}

export { BasicList }

export default BasicList;